<template>
    <div v-wechat-title="title" class="padding5">
        <el-row>
            <el-col :span="8" class="align-left">
                <item-input type="select" style="height: 32px; line-height: 32px" v-model="searchType" :options="searchTypeOption" placeholder="请选择时间类型"></item-input>
            </el-col>
            <el-col :span="16" class="align-left">
                <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
            </el-col>
        </el-row>
        <el-row v-wechat-title="title" class="usage-drug-event">
            <el-col :span="24" style="background-color: #fff; margin-top: 3px">
                <el-row style="margin: 5px 0px 5px 0px">
                    <el-col :span="6" class="align-center">
                        <el-button :type="scheduledType == 1 ? 'primary' : 'plain'" size="mini" @click="LoadScheduled(1)" title="待排程">
                            <span>待排程</span><span v-if="scheduledType == 1">({{ scheduledTypeDataCount }})</span></el-button
                        >
                    </el-col>
                    <el-col :span="6" class="align-center">
                        <el-button :type="scheduledType == 2 ? 'primary' : 'plain'" size="mini" @click="LoadScheduled(2)" title="已排程">
                            <span>已排程<span v-if="scheduledType == 2">({{ scheduledTypeDataCount }})</span></span>
                        </el-button>
                    </el-col>
                    <el-col :span="6" class="align-center" v-if="isShowWorkers">
                        <el-button ref="otherScheduledbtn" :type="scheduledType == 3 ? 'primary' : 'plain'" size="mini" @click="LoadScheduled(3)" title="其他">
                            <span style="float: right; padding-right: 5px">其他</span>
                        </el-button>
                    </el-col>
                    <el-col :span="6" class="align-center" v-if="isShowWorkers">
                        <el-button ref="otherScheduledbtn" :type="scheduledType == 4 ? 'primary' : 'plain'" size="mini" @click="loadWorkers()" title="人员">
                            <span style="float: right; padding-right: 5px">人员</span>
                        </el-button>
                    </el-col>
                </el-row>
                <template v-if="this.scheduledType == 1 || this.scheduledType == 2">
                    <el-checkbox v-model="isAll" size="mini"></el-checkbox>
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKey"
                        placeholder="关键字搜索"
                        size="mini"
                        :autofocus="true"
                        style="width: 85%; display: inline-block"
                    ></item-input>
                    <el-popover popper-class="surgery-index-popover" placement="right-start" width="560" trigger="click">
                        <div>
                            <div>
                                <h3>分组</h3>
                                <item-input type="radio" v-model="groupbymodel" :options="groupbyList" :borderd="true"></item-input>
                            </div>

                            <div>
                                <h3>筛选</h3>
                                <item-input type="radio" v-model="sxvalue" :options="groupItemList" :borderd="true"></item-input>
                            </div>
                            <div>
                                <h3>排序</h3>
                                <item-input type="radio" v-model="orderbymodel" :options="orderByList" :borderd="true"></item-input>
                            </div>
                        </div>
                        <el-link slot="reference" class="align-right" style="font-weight: bold; font-size: 20px">+</el-link>
                    </el-popover>
                </template>
                                <template v-if="this.scheduledType == 3">
                    <el-checkbox v-model="isAllOther" size="mini"></el-checkbox>
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKeyOther"
                        placeholder="名称"
                        size="mini"
                        :autofocus="true"
                        style="width: 85%; display: inline-block"
                    ></item-input>
                    <span class="el-link--inner" style="font-weight: bold; font-size: 26px; cursor: pointer" @click="addotherscheduleBefore()">+</span>
                </template>
                <template v-if="this.scheduledType == 4">
                    <item-input
                        type="string"
                        class="margin5 margin-none-h"
                        v-model="searchKeydutyworker"
                        placeholder="关键字搜索"
                        size="mini"
                        :autofocus="true"
                        style="width: 85%; display: inline-block"
                    ></item-input>
                </template>
                <el-scrollbar id="external-events" style="border: solid 0.5px lightgray; margin-bottom: 0px" :style="{ height: `${this.screenHeight2 - 250}px` }">
                    <div class="el-backtop" v-if="this.scheduledType == 1 && this.checkedRow.length > 0 && rightCurrentView == 'C'" style="position: absolute; bottom: 50%; right: 40px">
                        <el-button
                            icon="el-icon-right"
                            title="点击可批量排程手术"
                            @click="batchScheduling"
                            type="primary"
                            circle
                            style="width: 40px; height: 40px; padding: 5px !important"
                        ></el-button>
                    </div>
                    <el-menu class="cus-menu-v surgery" :default-openeds="defaultOpeneds" mode="vertical">
                        <template v-if="this.scheduledType == 1 || this.scheduledType == 2">
                            <div v-if="ScheduleSearchResult.length == 0" class="fg-info" style="text-align: center">暂无手术</div>
                            <div v-for="item in ScheduleSearchResult" :key="item.key">
                                <el-submenu :index="item.key" :class="showSurgeryTypeBGColor=='1' &&item.name.indexOf('门诊')>-1?'surgeryStatusbgColor':''">
                                    <div slot="title" class="cus-collapse-item surgery-header">
                                        <span slot="title">{{ item.name }}</span>
                                        <span
                                            class="cus-button is-circle"
                                            style="background: #ffffff; line-height: 10px; color: var(--primary-color, #009688); display: inline-flex; width: 20px; justify-content: center; height: 20px"
                                            >{{ item.children.length }}</span
                                        >
                                    </div>
                                    <div
                                        v-for="row in item.children"
                                        :key="row.id"
                                        :id="row.id"
                                        @dblclick="dbschedule(row)"
                                        class="event"
                                        @click="siwtchBtn($event, row)"
                                        @contextmenu.prevent="rightschedule(row)"
                                        :style="{ backgroundColor: row.checked ? 'var(--primary-lighter, rgba(0, 150, 136, 0.2))' : row.mouseFlag ? 'var(--primary-lighter, rgba(0, 150, 136, 0.2))' : '' }"
                                    >
                                        <el-row style="border-bottom: 0.5px solid lightgray; cursor: pointer; padding: 5px 0px 5px 0px">
                                            <el-col :span="1"  :class="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0'?'height-p120':''">
                                                <el-checkbox v-model="row.checked" class="switch" size="mini" @change="changeCheck($event, row)" onClick="event.stopPropagation()"></el-checkbox>
                                            </el-col>
                                            <el-col :span="1" v-show="scheduledType == 2" :class="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0'?'height-p120':''">
                                                <div
                                                    class="surgery-status-tag"
                                                    :title="row.surgery_status"
                                                    :style="{ height: IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' ? `${schedulingInfoConfig && (schedulingInfoConfig.length * 20) + 20}px` : '20px',marginLeft:'4px' }"
                                                    :class="
                                                    row.enum_surgery_status == 40
                                                            ? 'bg-end'
                                                            : row.enum_surgery_status == 30
                                                            ? 'bg-danger'
                                                            : row.enum_surgery_status == 20 || row.enum_surgery_status == 10
                                                            ? 'bg-primary'
                                                            : 'bg-info'
                                                    "
                                                >
                                                </div>
                                            </el-col>
                                            <el-col :span="22" class="padding5 padding-none-v align-left" style="padding-bottom: 5px" :title="titleLabel(row)">
                                                <div class="ellipsis">
                                                    <b>
                                                        <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
                                                        {{ row.patient_name }}
                                                        <span style="font-size: 14px">
                                                            {{ `(${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)` }}
                                                        </span>

                                                        <span v-if="isChecked(row) != ''" class="circle fg-red borderd surgery-num-tag">{{ isChecked(row) }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`surgeries`)">
                                                    <b>
                                                        <span class="ellipsis font-size12">•{{ row.surgeries }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`diseases`)">
                                                    <b>
                                                        <span class="ellipsis font-size12">•{{ row.diseases }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`anaes_methods`)">
                                                    <b>
                                                        <span class="ellipsis font-size12">•{{ row.anaes_methods }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`push_time`)">
                                                    <b>
                                                        <span class="ellipsis font-size12" style="color:red">推送时间：{{row.push_time&&$moment( row.push_time).format(`YYYY/MM/DD HH:mm`) }}</span>
                                                    </b>
                                                </div>
                                                <el-row v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`apply_time`)">
                                                    <el-col :span="16">
                                                        <b>
                                                            <span class="ellipsis font-size12">申请时间：{{ $moment(row.apply_time).format(`YYYY/MM/DD HH:mm`) }}</span>
                                                        </b> </el-col
                                                    ><el-col :span="8" v-show="!(orderbymodel==`scheduled_sequence|asc`||orderbymodel==`scheduled_sequence|desc`)">
                                                        <b>
                                                            <span class="ellipsis font-size12">申请台次：{{ row.sequence }}</span>
                                                        </b>
                                                    </el-col></el-row
                                                >
                                                <el-row v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`plan_time`)">
                                                    <el-col :span="16">
                                                        <b>
                                                            <span class="ellipsis font-size12">计划时间：{{ row.plan_time ? $moment(row.plan_time).format(`YYYY/MM/DD HH:mm`) : '' }}</span>
                                                        </b> </el-col
                                                    ><el-col :span="8" v-show="orderbymodel==`scheduled_sequence|asc`||orderbymodel==`scheduled_sequence|desc`">
                                                        <b>
                                                            <span class="ellipsis font-size12">排程台次：{{ row.scheduled_sequence }}</span>
                                                        </b>
                                                    </el-col>
                                                </el-row>

                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`surgeon`)">
                                                    <b>
                                                        <span class="ellipsis font-size12">{{ T(`apply_surgery.plan_surgeon`) }}：{{ row.surgeon }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0' && schedulingInfoConfig && schedulingInfoConfig.includes(`his_remark`)">
                                                    <b>
                                                        <span class="ellipsis font-size12">备注：{{ row.his_remark }}</span>
                                                    </b>
                                                </div>
                                                <div v-show="IsSimpleModeSchedulingInfo && IsSimpleModeSchedulingInfo =='0'">
                                                    <b>
                                                        <el-tag
                                                            v-for="surgeryTipItem in row.surgeryTipItemsList"
                                                            :key="surgeryTipItem.label"
                                                            :title="surgeryTipItem.title"
                                                            :style="surgeryTipItem.style"
                                                            style="margin-right: 3px;"
                                                            size="mini"
                                                            :closable="surgeryTipItem.title && surgeryTipItem.title.startsWith('个人标签')"
                                                            @close="delPatientTip(surgeryTipItem.label,row.id)"
                                                            >{{ surgeryTipItem.label }}</el-tag
                                                        >
                                                        <span class="el-icon-plus cus-buttons" v-has-permission="addpatientTipPermission"  title="添加患者标签" @click="addSurgeryTips(row.id,`(${row.patient_name}/${row.sex || '--'}/${row.age || '--'}/${row.visit_no || '--'}/${row.outpatient_no || '--'}/${row.bed_no || '--'}床)`)"></span>
                                                    </b>
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-submenu>
                            </div>
                        </template>
                        <template v-if="this.scheduledType == 3">
                            <div v-for="item in OtherScheduleSearchResult" :key="item.id" :id="item.id" @click="siwtchBtn($event, item)">
                                <el-row style="border-bottom: 0.5px solid lightgray; cursor: pointer">
                                    <el-col :span="1" class="height-p100" style="line-height: 80px">
                                        <el-checkbox v-model="item.checked" class="switch" size="mini" @change="changeCheck($event, item)"></el-checkbox>
                                    </el-col>
                                    <el-col :span="22" class="padding5 padding-none-v align-left">
                                        <el-row class="card-header">
                                            <el-col :span="18" class="align-right">
                                                <div class="ellipsis" style="text-align: left">
                                                    <b>
                                                        {{ item.name }}
                                                    </b>
                                                </div>
                                            </el-col>
                                            <el-col :span="6" class="align-right">
                                                <span class="cus-button is-circle el-icon-edit fg-info" title="编辑" @click="editotherschedule(item)"></span>
                                                <span class="cus-button is-circle el-icon-delete fg-info" title="删除" @click="removeotherschedule(item)"></span>
                                            </el-col>
                                        </el-row>

                                        <div>
                                            <span class="" style="font-size: 12px"
                                                >{{ $moment(item.effective_start_time).format(`YYYY/MM/DD`) }}~{{ $moment(item.effective_end_time).format(`YYYY/MM/DD`) }}</span
                                            >

                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span class="" style="font-size: 12px">{{ $moment(item.start_time).format(`HH:mm`) }}~ {{item.end_time && $moment(item.end_time).format(`HH:mm`) }}</span>
                                        </div>
                                        <div>
                                            <span style="font-size: 12px">重复：{{ item.repeat_mode_name }}</span>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span style="font-size: 12px">{{ item.repeat_values_name }}</span>
                                        </div>
                                        <!-- <div v-if="isShowDiseases && isShowDiseases == '1'">
                            <b class="ellipsis">{{ row.diseases }}</b>
                        </div> -->
                                    </el-col>
                                </el-row>
                            </div>
                        </template>
                        <template v-if="this.scheduledType == 4">
                            <el-row style="margin: 5px 0px 5px 0px">
                                <el-col :span="6" class="align-center">
                                    <el-button :type="workerDuty == 1 ? 'primary' : 'plain'" size="mini" @click="loadWorkersByDuty(1)" title="麻醉医生">
                                        <span style="float: right; padding-right: 5px">麻醉医生</span></el-button
                                    >
                                </el-col>
                                <el-col :span="6" class="align-center">
                                    <el-button :type="workerDuty == 2 ? 'primary' : 'plain'" size="mini" @click="loadWorkersByDuty(2)" title="麻醉助手">
                                        <span style="float: right; padding-right: 5px">麻醉助手</span>
                                    </el-button>
                                </el-col>
                                <el-col :span="6" class="align-center">
                                    <el-button :type="workerDuty == 3 ? 'primary' : 'plain'" size="mini" @click="loadWorkersByDuty(3)" title="巡回护士">
                                        <span style="float: right; padding-right: 5px">巡回护士</span>
                                    </el-button>
                                </el-col>
                                <el-col :span="6" class="align-center">
                                    <el-button :type="workerDuty == 4 ? 'primary' : 'plain'" size="mini" @click="loadWorkersByDuty(4)" title="器械护士">
                                        <span style="float: right; padding-right: 5px">器械护士</span>
                                    </el-button>
                                </el-col>
                            </el-row>
                            <div>
                                <!-- @click="siwtchdutyBtn($event, row)"  @click="siwtchdutyBtn($event, row)" -->
                                <!-- @dblclick="setRoomDutyWorker(workerDuty, row.value)" -->
                                <div v-for="row in unSettingWorkersSearchResult" :key="row.id" :id="row.id" @dblclick="setRoomDutyWorker(workerDuty, row.id)" @click="siwtchdutyBtn($event, row)">
                                    <el-row style="cursor: pointer; padding: 5px 5px 5px 15px" class="align-left">
                                        <el-col :span="1" v-show="workerDuty !== 1">
                                            <el-checkbox
                                                v-model="row.checked"
                                                class="switch"
                                                style="line-height: 40px; height: 40px"
                                                size="mini"
                                                @change="changeCheck($event, row)"
                                                onClick="event.stopPropagation()"
                                            ></el-checkbox>
                                        </el-col>
                                        <el-col :span="23">
                                            <div class="ellipsis" style="border-bottom: 0.5px solid lightgray; line-height: 40px; height: 40px">{{ row.name }}</div>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </template>
                    </el-menu>
                </el-scrollbar>
            </el-col>
        </el-row>
        <form-dialog
            ref="otherscheduleform"
            title="添加其他排程"
            :data="otherscheduleEditData.data"
            width="50%"
            class="form-table-h360"
            labelWidth="300"
            :visible.sync="otherscheduleEditData.dialogFormVisible"
            :columns="otherscheduleEditData.ColumnList"
            @confirm="saveotherschedule"
        ></form-dialog>
        <EditSurgery
            ref="leftEditSurgery"
            :surgeryId="editSurgeryInfo.surgeryId"
            :visible.sync="editSurgeryInfo.dialogFormVisible"
            :isReadOnly="editSurgeryInfo.isReadOnly"
            :editButtons="editButtons"
            :readOnlyExcludeColumns="editSurgeryInfo.readOnlyExcludeColumns"
            @after-save="afterSave"
            @save="save"
        ></EditSurgery>
       <SurgeryTips width="30%" ref="addSurgeryTip" :dialogVisible.sync="SurgeryTips.dialogFormVisible" :patientInfo="SurgeryTips.patientInfo" :surgeryId="SurgeryTips.surgeryId" @afterClose="afterClose"></SurgeryTips>
    </div>
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import { Draggable } from '@fullcalendar/interaction'
import { mapGetters } from 'vuex'
import EditSurgery from './EditSurgery.vue'
import SurgeryTips from '@/common/SurgeryTips.vue'
export default {
    name: `LeftScheduleSurgery`,
    components: { FullCalendar, Draggable, EditSurgery, SurgeryTips },
    props: {
        userListColumn: Array,
        userListShowColumn: Array
    },
    data() {
        let validateeffectivetime = (rule, value, callback) => {
            if (this.$refs.otherscheduleform.$refs.form.formdata.effectivetime.length < 2) {
                callback(new Error(`请选择有效时间!`))
            } else if (this.$refs.otherscheduleform.$refs.form.formdata.repeat_mode == 1) {
                let tmpstart = this.$refs.otherscheduleform.$refs.form.formdata.effectivetime.length >= 2 ? this.$refs.otherscheduleform.$refs.form.formdata.effectivetime[0] : ``
                let tmpend = this.$refs.otherscheduleform.$refs.form.formdata.effectivetime.length >= 2 ? this.$refs.otherscheduleform.$refs.form.formdata.effectivetime[1] : ``
                let start = this.$moment(tmpstart).format(`YYYY/MM/DD`)
                let end = this.$moment(tmpend).format(`YYYY/MM/DD`)
                if (start != end) {
                    callback(new Error(`有效时间请选择同一天!`))
                } else {
                    callback()
                }
            } else if (this.$refs.otherscheduleform.$refs.form.formdata.repeat_mode == 3 && this.$refs.otherscheduleform.$refs.form.formdata.effectivetime.length < 2) {
                callback(new Error(`请选择有效时间!`))
            } else {
                callback()
            }
        }
        let validatemode = (rule, value, callback) => {
            if (this.$refs.otherscheduleform.$refs.form.formdata.repeat_mode === 4 && (this.$refs.otherscheduleform.$refs.form.formdata.repeat_value == null || this.$refs.otherscheduleform.$refs.form.formdata.repeat_value == ``)) {
                callback(new Error(`请选择有效执行天数!`))
            } else {
                callback()
            }
        }
        let validatestarttime = (rule, value, callback) => {
            if (this.$refs.otherscheduleform.$refs.form.formdata.start_time == ``) {
                callback(new Error(`请选择开始时间!`))
            } else {
                callback()
            }
        }
        let validateendtime = (rule, value, callback) => {
            if (this.$refs.otherscheduleform.$refs.form.formdata.end_time == ``) {
                callback(new Error(`请选择结束时间!`))
            } else {
                callback()
            }
        }

        // 读取 记忆设置的内容
        let memoryCondition = sessionStorage.getItem(`memory_leftCalendar`)
        let memory = null
        if (memoryCondition) {
            memory = JSON.parse(memoryCondition)
        }
        // 如果单独设置了 日历排程的 默认加载日期，就用日历排程的设置，一些医院要求：列表排程和日历排程设置的日期区分开来
        let ScheduleQueryDateOffset = this.$root.FullcalendarQueryDateOffset || this.$root.ScheduleQueryDateOffset
        let offset = (ScheduleQueryDateOffset || ``).split(`,`)
        let firstOffSetDate = 0
        let secondOffSetDate = 1
        if (offset && offset.length == 3) {
            firstOffSetDate = offset[1]
            secondOffSetDate = offset[2]
        }

        return {
            lastalertmsg: ``,
            title: `手术排程`,
            sxvalue: memory && memory.memory_sxvalue ? memory.memory_sxvalue : 0,
            firstLoad: true, // 是否首次加载
            otherScheduleIntervalTime: 60,
            groupbymodel: memory && memory.memory_groupby ? memory.memory_groupby : this.$root.DefaultGroupBy,
            orderbymodel: memory && memory.memory_orderby ? memory.memory_orderby : this.$root.DefaultOrderBy,
            searchKey: memory && memory.memory_searchKey ? memory.memory_searchKey : ``,
            memory: memory,
            searchKeyOther: ``,
            searchKeydutyworker: ``,
            searchType: memory && memory.memory_searchType ? memory.memory_searchType : this.$root.DefaultSearchType,
            scheduledType: memory && memory.memory_scheduledType ? memory.memory_scheduledType : 1,
            groupbyList: [
                { value: `dic_section_id`, label: `科室` },
                { value: `dic_operating_room_id`, label: `手术间` },
                { value: `enum_surgery_type`, label: `手术类型` },
                { value: `surgeon_id`, label: `手术医生` },
                { value: `anaes_surgeon_id`, label: `麻醉医生` }
                //, { value: 'plan_anes_assistants', label: '麻醉方式' }
            ],
            orderByList: [
                { value: `plan_time|asc`, label: `计划手术时间↑` },
                { value: `plan_time|desc`, label: `计划手术时间↓` },
                { value: `sequence|asc`, label: `申请台次↑` },
                { value: `sequence|desc`, label: `申请台次↓` },
                { value: `scheduled_sequence|asc`, label: `排程台次↑` },
                { value: `scheduled_sequence|desc`, label: `排程台次↓` },
                { value: `apply_time|asc`, label: `手术申请时间↑` },
                { value: `apply_time|desc`, label: `手术申请时间↓` },
                { value: `enum_surgery_type|asc`, label: `手术类型↑` },
                { value: `enum_surgery_type|desc`, label: `手术类型↓` },
                { value: `surgeries|asc`, label: `拟施手术↑` },
                { value: `surgeries|desc`, label: `拟施手术↓` },
                { value: `dic_section_order|asc`, label: `科室↑` },
                { value: `dic_section_order|desc`, label: `科室↓` },
                { value: `surgeon|asc`, label: `手术医生↑` },
                { value: `surgeon|desc`, label: `手术医生↓` },
                { value: `anaes_surgeon|asc`, label: `麻醉医生↑` },
                { value: `anaes_surgeon|desc`, label: `麻醉医生↓` },
                { value: `anaes_methods|asc`, label: `麻醉方式↑` },
                { value: `anaes_methods|desc`, label: `麻醉方式↓` }
            ],
            groupItemList: [],
            rdate: memory && memory.memory_rdate ? memory.memory_rdate : [this.$moment().add(firstOffSetDate, `days`).format(`YYYY/MM/DD`), this.$moment().add(+secondOffSetDate, `days`).format(`YYYY/MM/DD`)],
            isShowDiseases: this.$root.IsShowDiseases,
            scheduledTypeDataCount: 0,
            groupByModelLable: { 'dic_section_id': `dic_section`,
                'dic_operating_room_id': `dic_operating_room`,
                'enum_surgery_type': `surgery_type`,
                'surgeon_id': `surgeon`,
                'anaes_surgeon_id': `anaes_surgeon`
                //, '': `麻醉方式`
            },
            schedule_list: [

            ],
            schedule_list_all: [

            ],
            otherschedule_list: [

            ],
            otherschedule_list_all: [

            ],
            editSurgeryInfo: {
                dialogFormVisible: false,
                surgeryId: 0,
                isReadOnly: true,
                readOnlyExcludeColumns: [`术前诊断`, `手术助手`, `年龄`, `备注`, `麻醉医生`, `麻醉助手`, `巡回护士`, `洗手护士`, `手术时间`, `预计时长`]
            },
            SurgeryTips: {
                dialogFormVisible: false,
                surgeryId: 0,
                patientInfo: ``
            },
            editButtons: [{
                label: `确认排程`,
                type: `default`,
                permission: `ApplySurgery:ConfirmSchedule`
            }],
            otherscheduleEditData: {
                dialogFormVisible: false,
                data: {},
                ColumnList: [
                    {
                        type: `string`,
                        prop: `name`,
                        label: `名称`,
                        isCreatable: true,
                        isEditable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        colspan: 24
                    },

                    {
                        type: `select`,
                        prop: `repeat_mode`,
                        label: `执行频率`,
                        isCreatable: true,
                        isEditable: true,
                        validate: [{ validator: validatemode, trigger: `blur` }],
                        options: [{ label: `一次`, value: 1 }, { label: `每天`, value: 3 }, { label: `每周`, value: 4 }],
                        colspan: 24,
                        change: (that, { row, index }) => {
                            if (row.repeat_mode === 1) {
                                row.effectivetime = [
                                    this.$moment().format(`YYYY/MM/DD`), this.$moment().format(`YYYY/MM/DD`)
                                ]
                            }
                        }
                    },
                    {
                        type: `checkboxgroup`,
                        prop: `repeat_value`,
                        label: ``,
                        options: [{ label: `周一`, value: `1` }, { label: `周二`, value: `2` }, { label: `周三`, value: `3` }, { label: `周四`, value: `4` }, { label: `周五`, value: `5` }, { label: `周六`, value: `6` }, { label: `周日`, value: `0` }],
                        readonly: function(that, { row, area }) {
                            return row.repeat_mode && (row.repeat_mode == 1 || row.repeat_mode == 3)
                        },
                        colspan: 24
                    },
                    {
                        type: `daterange`,
                        prop: `effectivetime`,
                        label: `有效时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 17,
                        validate: [{ validator: validateeffectivetime, trigger: `blur` }],
                        default: [
                            this.$moment().format(`YYYY/MM/DD`), this.$moment()
                                .add(+7, `day`)
                                .format(`YYYY/MM/DD`)
                        ]
                    },
                    {
                        type: `time`,
                        prop: `start_time`,
                        label: `开始时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 8,
                        validate: [{ validator: validatestarttime, trigger: `blur` }],
                        default: this.$moment().format(`YYYY/MM/DD HH:mm`)
                    },
                    {
                        type: `time`,
                        prop: `end_time`,
                        label: `结束时间`,
                        isCreatable: true,
                        isEditable: true,
                        colspan: 8,
                        validate: [{ validator: validateendtime, trigger: `blur` }],
                        default: this.$moment().add(+1, `hours`).format(`YYYY/MM/DD HH:mm`)
                    },
                    {
                        type: `checkbox`,
                        prop: `is_limit_time`,
                        label: `不限`,
                        isCreatable: true,
                        isEditable: true,
                        readonly: false,
                        colspan: 4,
                        default: false,
                        change: (that, { row, index }) => {
                            if (row.is_limit_time) {
                                row.start_time = this.$moment(row.start_time).format(`YYYY/MM/DD 00:00`)
                                row.end_time = this.$moment(row.end_time).format(`YYYY/MM/DD 23:59`)
                            }
                        },
                        config: { popperAppendToBody: true }
                    },
                    {
                        type: `multiselect`,
                        prop: `tmp_operatingroom_ids`,
                        label: `手术间`,
                        showCount: 20,
                        collapseTags: false,
                        isCreatable: true,
                        isEditable: true,
                        validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                        options: (that, { row }) => {
                            let data = _.filter(this.operation_ward_auth_disabled, (d) => {
                                return (d.value == this.dic_operating_ward_id)
                            })
                            let rooms = _.filter(data[0] && data[0].operation_room, (d) => {
                                return d.disabled === false
                            }) || []
                            return _.orderBy(rooms, `display_order`)
                        },
                        colspan: 24
                    },
                    {
                        type: `textarea`,
                        prop: `remark`,
                        label: `备注`,
                        colspan: 24,
                        config: {
                            minRows: 2
                        }
                    }
                ]
            },
            checkedRow: [],
            draggableCollection: [],
            timer_interval: null,
            choosen: undefined,
            o_dic_operating_ward_id: undefined, // 排程手术区
            is_change_operating_wardId: false, // 手术区是否被调整过
            FilterByOperatingWard: !!(this.$root.CalendarFilterByOperatingWard && (this.$root.CalendarFilterByOperatingWard == 1 || this.$root.CalendarFilterByOperatingWard == `1`)), // 是否开启了跨区域排程 数据过滤
            isShowInfectiousAlert: this.$root.IsShowInfectiousAlert,
            showSurgeryAlert: this.$root.proc_ShowSurgeryAlert,
            IsSimpleModeSchedulingInfo: this.$root.IsSimpleModeSchedulingInfo,
            isShowInfectiousAlertConfigs: [],
            workerDuty: 1,
            // workers_all: { '麻醉医生': [{ value: 1, label: `1111`, checked: false }, { value: 2, label: `22222`, checked: false }] }
            workers_all: [],
            used_workers: [],
            un_setting_workers: [],
            showSurgeryTypeBGColor: this.$root.showSurgeryTypeBGColor,
            addpatientTipPermission: `scheduling:addpatientTip`, // 添加患者标签权限
            schedulingInfoConfig: this.$root.SchedulingInfoConfig && this.$root.SchedulingInfoConfig.split(`|`) || [],
            isShowWorkers: this.$root.IsShowWorkers == `1`
        }
    },
    created() {
        this.init()
        if (this.timer_interval) {
            window.clearInterval(this.timer_interval)
            this.timer_interval = null
        }
        if (this.isShowInfectiousAlert && this.isShowInfectiousAlert.trim() != ``) {
            let config = JSON.parse(this.isShowInfectiousAlert)
            if (config && config.length > 0) {
                this.isShowInfectiousAlertConfigs = config.filter(d => {
                    return d.IsEnable && d.IsEnable == 1
                })
            }
        }
        this.lastalertmsg = ``
    },
    mounted() {
        if (!this.timer_interval && this.getSurgeryInfoSyncTime() > 0) {
            // 开启定时器，定时获取手术
            this.timer()
        }
    },
    computed: {
        ...mapGetters([`ward_auth`, `section_auth`, `operation_ward`, `operation_ward_auth`, `operation_ward_auth_disabled`, `currentUser`, `sys_enums`, `active_ward`, `drug/drug_type`, `drug/drug_unit`, `drug/drug_way`, `screenHeight`, `permissions`,
            `otherSettingColumn`,
            `sysuser/workers_by_duty`,
            `extendColumnList`]),
        screenHeight2() {
            return this.screenHeight
        },
        searchTypeOption() {
            return [{ label: `申请时间`, value: 1 }, { label: `计划时间`, value: 2 }]
        },
        IsCrossRegionScheduling() {
            return _.find(this.permissions, { no: `scheduling:CrossRegionScheduling` }) != undefined
        },
        IsMoveEmergencyPermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveEmergency` }) != undefined
        },
        IsMoveElectivePermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveElective` }) != undefined
        },
        IsMoveDeadlinePermission() {
            return _.find(this.permissions, { no: `scheduling_list_moveDeadline` }) != undefined
        },
        IsMovePermission() {
            return _.find(this.permissions, { no: `scheduling_list_toScheduling` }) != undefined
        },
        isCardRemove() {
            return _.find(this.permissions, { no: `scheduling_cardRemove` }) != undefined
        },
        isHaveCardEdit() {
            return _.find(this.permissions, { no: `scheduling_surgeryEdit` }) != undefined
        },
        dic_operating_ward_id: {
            get: function() {
                let wardid = sessionStorage.getItem(`memory_operating_ward_id`)
                if (!this.is_change_operating_wardId && wardid) {
                    this.o_dic_operating_ward_id = wardid
                } else if (!this.is_change_operating_wardId && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                // 手术区没有被调整过直接取右上角手术区
                // 手术区记忆功能逻辑：首次进来加载已经记忆的手术区，若没有记忆 按上面逻辑的手术区

                this.firstLoad = false
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.is_change_operating_wardId = true
            }
        },
        isAllOther: {
            // 全选影响小选
            set(val) {
                if (val == true) {
                    this.checkedRow = this.checkedRow || _.filter(this.otherschedule_list, d => { return d.checked == true }) || []
                    this.otherschedule_list.forEach((obj) => {
                        if (obj.checked != true) {
                            obj.checked = true
                            this.checkedRow.push(obj)
                        }
                    })
                } else {
                    this.otherschedule_list.forEach((obj) => (obj.checked = false))
                    this.checkedRow = []
                }
            },
            // 小选框影响全选框
            get() {
                if (this.otherschedule_list.length == 0) {
                    return false
                }
                return this.otherschedule_list.every((obj) => obj.checked === true)
            }
        },
        isAll: {
            // 全选影响小选
            set(val) {
                if (val == true) {
                    this.checkedRow = this.checkedRow || _.filter(this.schedule_list, d => { return d.checked == true }) || []
                    this.schedule_list.forEach((obj) => {
                        if (obj.checked != true) {
                            obj.checked = true
                            this.checkedRow.push(obj)
                        }
                    })
                } else {
                    this.schedule_list.forEach((obj) => (obj.checked = false))
                    this.checkedRow = []
                }
            },
            // 小选框影响全选框
            get() {
                if (this.schedule_list.length == 0) {
                    return false
                }
                return this.schedule_list.every((obj) => obj.checked === true)
            }
        },
        ScheduleSearchResult() {
            let that = this
            if (this.schedule_list_all.length == 0) {
                that.groupItemList = []
            }
            let sk = (this.searchKey && this.searchKey.toUpperCase()) || ``
            let groupbykey = this.groupbymodel
            let groupbyvalue = this.groupByModelLable[this.groupbymodel]

            let orderbykey = this.orderbymodel
            // 数据未处理前，记录右边筛选数据源
            that.groupItemList = []
            that.groupItemList.push({
                label: `全部`,
                value: 0
            })

            _.reduce(
                _.groupBy(this.schedule_list_all, groupbykey),
                function(result, g, key) {
                    that.groupItemList.push({
                        label: (g[0][groupbyvalue] == null || g[0][groupbyvalue] == ``) ? `未分配` : g[0][groupbyvalue],
                        value: g[0][groupbykey]
                    })
                    return result
                },
                []
            )
            // 数据未处理前，记录右边筛选数据源 END
            let r = _.filter(this.schedule_list_all, d => {
                let result = true
                if (this.sxvalue != 0) {
                    console.log(d)
                    console.log(d[groupbykey])
                    result = d[groupbykey] == this.sxvalue
                }
                if (result && sk.length > 0) {
                    result =
                        (d.patient_abbr && d.patient_abbr.toUpperCase().indexOf(sk) > -1) ||
                        (d.patient_name && d.patient_name.toUpperCase().indexOf(sk) > -1) ||
                        (d.visit_no && d.visit_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.outpatient_no && d.outpatient_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.sex && d.sex.toUpperCase().indexOf(sk) > -1) ||
                        (d.bed_no && d.bed_no.toUpperCase().indexOf(sk) > -1) ||
                        (d.surgeries && d.surgeries.toUpperCase().indexOf(sk) > -1) ||
                        (d.diseases && d.diseases.toUpperCase().indexOf(sk) > -1)
                }
                return result
            })
            that.schedule_list = []
            r = _.reduce(
                _.groupBy(r, groupbykey),
                function(result, g, key) {
                    console.log(orderbykey)
                    if (orderbykey && orderbykey.split(`|`).length > 1) {
                        let orderbyarray = orderbykey.split(`|`)
                        let orderby1 = orderbyarray[0]
                        let orderby2 = orderbyarray[1]
                        if (orderby2 == `asc`) {
                            g = g.sort(function(a, b) {
                                var x = a[orderby1]
                                var y = b[orderby1]
                                return x > y ? 1 : x < y ? -1 : 0
                            })
                        } else {
                            g = g.sort(function(a, b) {
                                var x = a[orderby1]
                                var y = b[orderby1]
                                return x > y ? -1 : x < y ? 1 : 0
                            })
                        }
                        if (g && g.length > 0) {
                            g && g.forEach(item => {
                                that.schedule_list.push(item)
                            })
                        }
                    }
                    result.push({
                        key: `key_${key}`,
                        name: g[0][groupbyvalue] == null ? `未分配` : g[0][groupbyvalue],
                        children: g
                    })
                    return result
                },
                []
            )
            // 科室分组按科室dic_section_order 排序
            if (this.groupbymodel == `dic_section_id`) {
                if (orderbykey && orderbykey.split(`|`).length > 1) {
                    let orderbyarray = orderbykey.split(`|`)
                    let orderby2 = orderbyarray[1]
                    if (orderby2 == `asc`) {
                        r = r.sort(function(a, b) {
                            var aDicOrder = a.children && a.children.length > 0 ? a.children[0].dic_section_order : 0
                            var bDicOrder = b.children && b.children.length > 0 ? b.children[0].dic_section_order : 0
                            return aDicOrder > bDicOrder ? 1 : aDicOrder < bDicOrder ? -1 : 0
                        })
                    } else {
                        r = r.sort(function(a, b) {
                            var aDicOrder = a.children && a.children.length > 0 ? a.children[0].dic_section_order : 0
                            var bDicOrder = b.children && b.children.length > 0 ? b.children[0].dic_section_order : 0
                            return aDicOrder > bDicOrder ? -1 : aDicOrder < bDicOrder ? 1 : 0
                        })
                    }
                }
            }
            // 待排程且有卡片移动权限
            if (that.scheduledType == 1 && that.schedule_list.length > 0 && that.isCardRemove) {
                if (this.IsMovePermission) {
                    this.createDraggable(that.schedule_list)
                }
                // this.rowDrop()
            }
            return r
        },
        OtherScheduleSearchResult() {
            let sk = (this.searchKeyOther && this.searchKeyOther.toUpperCase()) || ``
            let r = _.filter(this.otherschedule_list, d => {
                let result = true
                if (result && sk.length > 0) {
                    result = d.name.toUpperCase().indexOf(sk) > -1
                }
                return result
            })
            this.otherschedule_list_all = r
            return r
        },
        unSettingWorkersSearchResult() {
            let dutyname = ``
            switch (this.workerDuty) {
            case 1:
            case 2:
                dutyname = `麻醉医生`
                break
            case 3:
            case 4:
                dutyname = `巡回护士`
                break
            default:
                dutyname = `麻醉医生`
                break
            }
            let dutyworkers = _.filter(this.un_setting_workers, d => d.worker_duty == dutyname)
            if (this.searchKeydutyworker) {
                let q = (this.searchKeydutyworker && this.searchKeydutyworker.toUpperCase())
                dutyworkers = dutyworkers.filter(d => {
                    return d.name.indexOf(q) > -1 || d.card_no.indexOf(q) > -1 || d.abbr.indexOf(q) > -1
                })
            }
            return dutyworkers.sort((a, b) => a[`name`].localeCompare(b[`name`]))
        },
        titleLabel() {
            return function(row) {
                let that = this
                let rowCopy = Object.assign({}, row)
                var title = `${rowCopy.patient_name}(${rowCopy.sex || `--`}/${rowCopy.age || `--`}/${rowCopy.visit_no || `--`}/${rowCopy.outpatient_no || `--`}/${rowCopy.bed_no || `--`}床)\n`
                // {{ item.label }}:{{ arg.event.extendedProps[item.prop] }}
                var columns = that.userListShowColumn
                // reload的时候把动态列字段放到obj对象里面
                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, rowCopy, rowCopy)
                _.each(columns, item => {
                    if (typeof (rowCopy[item.prop]) == `boolean` && item.prop != `ischecked`) {
                        if (rowCopy[item.prop] == true) {
                            rowCopy[item.prop] = `是`
                        } else {
                            rowCopy[item.prop] = `否`
                        }
                    } else if (rowCopy[item.prop] && (rowCopy[item.prop] + ``).indexOf(`/Date`) > -1) {
                        rowCopy[item.prop] = this.$moment(rowCopy[item.prop]).format(`YYYY/MM/DD HH:mm`)
                    } else if (item.prop == `enum_visit_type`) {
                        if (rowCopy[item.prop] == 1) {
                            rowCopy[item.prop] = `住院`
                        } else if (rowCopy[item.prop] == 2) {
                            rowCopy[item.prop] = `门诊`
                        } else if (rowCopy[item.prop] == 3) {
                            rowCopy[item.prop] = `体检`
                        } else {
                            rowCopy[item.prop] = ``
                        }
                    }

                    title += `${item.label}:${rowCopy[item.prop] || ``}\n`
                })
                return title
            }
        },
        defaultOpeneds() {
            let r = _.map(this.ScheduleSearchResult, `key`)
            return r
        },
        rightCurrentView() {
            let rightScheduleSurgery = this.getRightScheduleSurgery()
            return rightScheduleSurgery && rightScheduleSurgery.currentView
        }

    },
    beforeDestroy() {
        clearInterval(this.timer_interval)
        this.timer_interval = null

        // 离开页面暂存页面已设置内容，方便下次进入 记忆功能
        var memoryCondition = {
            memory_searchKey: this.searchKey,
            memory_searchType: this.searchType,
            memory_rdate: this.rdate,
            memory_scheduledType: this.scheduledType,
            memory_groupby: this.groupbymodel,
            memory_orderby: this.orderbymodel,
            memory_sxvalue: this.sxvalue
        }
        sessionStorage.setItem(`memory_leftCalendar`, JSON.stringify(memoryCondition))
    },
    methods: {
        init() {
            // 默认加载待排程
            this.LoadScheduled(this.scheduledType).then((data) => {
            })
            if (this.isShowWorkers) {
                this.getWorkers()
                this.getotherScheduleIntervalTime()
            }
        },
        timer() {
            let that = this
            that.timer_interval = window.setInterval(() => {
                that.loadNewSurgeryList()
            }, this.getSurgeryInfoSyncTime())
        },
        getSurgeryInfoSyncTime() {
            let surgeryInfoSyncTime = 0
            if (this.$root.SurgeryInfoSyncTime && this.$root.SurgeryInfoSyncTime != 0 && this.$root.SurgeryInfoSyncTime != `0`) {
                let time = parseInt(this.$root.SurgeryInfoSyncTime)
                if (time && time > 0) {
                    surgeryInfoSyncTime = time * 60000 // 5分钟，5*60000
                }
            }
            return surgeryInfoSyncTime
        },
        // 新手术申请通知
        loadNewSurgeryList() {
            if (this.$root.IsShowNewSurgeryAlert && this.$root.IsShowNewSurgeryAlert == `1` && this.dic_operating_ward_id) {
                this.myaxios.getNoloading(`/api/Preoperative/Apply/GetNewApplySurgerys`, { wardId: parseInt(this.dic_operating_ward_id), syncMinutes: this.$root.SurgeryInfoSyncTime }).then(data => {
                    if (data && data.length > 0) {
                        // added by 是否显示新手术通知提示
                        let alertmsg2 = ``
                        _.filter(data, i => i.surgery_status == `新申请`).map(d => {
                            alertmsg2 += `<strong>${d.patient_name}是新手术申请</strong><br/>`
                        })
                        if (alertmsg2) {
                            this.$notify.info({
                                title: `提醒`,
                                dangerouslyUseHTMLString: true,
                                message: alertmsg2,
                                position: `bottom-right`,
                                duration: 15000,
                                offset: 100
                            })
                            return true
                        }
                    }
                })
            }
        },
        LoadScheduled(scheduledType) {
            this.scheduledType = scheduledType
            let that = this
            let conditions = this.getAllConditions()
            return new Promise(resolve => {
                let req
                if (scheduledType == 1) {
                    // 获取待排程
                    req = this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetSampleCalendarUnScheduled?searchType=${this.searchType}&begin=${this.rdate[0]}&end=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`)
                } else if (scheduledType == 2) {
                    // 获取已排程
                    req = this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetSampleCalendarScheduled?searchType=${this.searchType}&begin=${this.rdate[0]}&end=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`)
                } else if (scheduledType == 3) {
                    // 获取其他排程
                    req = this.myaxios.getNoloading(`/api/AcisSystem/OtherSchedule/GetByDateRange?begin=${this.rdate[0]}&end=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`)
                }
                // 获取手术提醒
                let req1 = this.myaxios.getNoloading(`/api/Preoperative/Schedule/GetSurgeryAlertInfo?begin=${this.rdate[0]}&end=${this.$moment(this.rdate[1]).add(1, `days`).format(`YYYY/MM/DD`)}`)
                // 获取tag标签
                let req2 = this.myaxios.post(`api/Nursing/Charge/GetSurgeryTipItems`, conditions, null, false)
                this.myaxios.all(req, req1, req2).then(([data, alertInfo, tags]) => {
                    console.log(`data`, data)
                    this.checkedRow = []
                    if (scheduledType == 1 || scheduledType == 2) {
                        // 1.没有跨区域排程权限 的要 过滤
                        // 2.即使有 跨区域排程权限，开启了 FilterByOperatingWard 根据手术区过滤数据的权限也要过滤数据，
                        //  注意：这样会使 左侧待排程和右侧日历 使用同一个手术区而无法实现拖拽跨区域排程，只能右键 跨区域排程
                        if (this.IsCrossRegionScheduling == false || this.FilterByOperatingWard == true) {
                            if (this.dic_operating_ward_id != undefined) {
                                data = _.filter(data, { dic_operating_ward_id: parseInt(this.dic_operating_ward_id) }).map(d => {
                                    return d
                                })
                            }
                        }
                        // added by xiaorui,ACIS-23994 ,手术排程 数据列表 安排术间增加了3个权限控制
                        // 只有待排程列表才加限制
                        if (scheduledType == 1) {
                            if (!this.IsMoveEmergencyPermission) {
                                data = _.filter(data, function(i) {
                                    return (i.enum_surgery_type !== 1 && i.enum_surgery_type !== null)
                                })
                            }
                            if (!this.IsMoveElectivePermission) {
                                data = _.filter(data, function(i) {
                                    return i.enum_surgery_type !== 2
                                })
                            }
                            if (!this.IsMoveDeadlinePermission) {
                                data = _.filter(data, function(i) {
                                    return i.enum_surgery_type !== 3
                                })
                            }
                        }

                        data = data.map(d => {
                            d.checked = false
                            if (tags && tags.length) {
                                let surgeryTip = tags.filter(i => i.biz_surgeryinfo_id == d.id)
                                let tipItem = surgeryTip || []
                                d.surgeryTipItemsList = tipItem
                            } else {
                                d.surgeryTipItemsList = []
                            }
                            that.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                            return d
                        })

                        this.schedule_list = data
                        this.schedule_list_all = data
                        this.otherschedule_list = []
                        this.otherschedule_list_all = []
                        this.scheduledTypeDataCount = 0
                        this.scheduledTypeDataCount = data.length
                    } else if (scheduledType == 3) {
                        data = data.map(d => {
                            d.checked = false
                            return d
                        })
                        this.schedule_list = []
                        this.schedule_list_all = []
                        this.otherschedule_list = data
                        this.otherschedule_list_all = data
                    }
                    this.searchKeyOther = ``
                    // 首次加载的时候有缓存seachKey搜索条件就加载手术条件，否则置空
                    this.searchKey = (this.firstLoad && this.memory && this.memory.memory_searchKey) ? this.memory.memory_searchKey : ``
                    this.firstLoad = false
                    resolve(data)
                    if (this.schedule_list.length > 0) {
                        let alertmsg = ``
                        // 存储过程
                        if (that.showSurgeryAlert && that.showSurgeryAlert.trim() != `` && alertInfo.length > 0) {
                            let ids = _.map(that.schedule_list, d => d.id)
                            alertInfo = _.filter(alertInfo, function(i) {
                                return _.includes(ids, i.biz_surgeryinfo_id)
                            })
                            console.log(alertInfo)
                            alertInfo.forEach(t => {
                                alertmsg += `<strong>${t.msg}</strong><br/>`
                            })
                        } else if (that.isShowInfectiousAlertConfigs && that.isShowInfectiousAlertConfigs.length > 0) {
                            that.isShowInfectiousAlertConfigs.forEach(t => {
                                _.filter(
                                    that.schedule_list,
                                    i => i[t.Field] && i[t.Field] != `无` && i[t.Field] != `NONE` && i[t.Field] != `NoCheck` && i[t.Field] != `未查` && i[t.Field] != `未检查`
                                ).map(d => {
                                    alertmsg += `<strong>${d.patient_name}是${d[t.Field]}${t.Remark}患者</strong><br/>`
                                })
                            })
                        }

                        if (alertmsg && alertmsg != `` && that.lastalertmsg != alertmsg) {
                            that.lastalertmsg = alertmsg
                            this.$alert(alertmsg, `提示`, {
                                dangerouslyUseHTMLString: true,
                                type: `warning`
                            })
                            return true
                        }
                    }
                }).catch(e => {
                    that.schedule_list = []
                    that.schedule_list_all = []
                    that.otherschedule_list = []
                    that.otherschedule_list_all = []
                })
            })
        },
        getAllConditions() {
            // 选复苏室则只看在当前复苏室的患者
            var queryCondition = {
                begin: this.rdate[0],
                end: this.$moment(this.rdate[1])
                    .add(1, `days`)
                    .format(`YYYY/MM/DD`),
                is_local_anes: 0,
                surgery_type: 0,
                charge_status: 0,
                surgery_status: [10, 20, 30, 40, 50, 60],
                dic_operating_room_id: 0,
                dic_recovery_ward_id: 0,
                dic_operating_ward_id: 0
            }

            return queryCondition
        },
        getotherScheduleIntervalTime() {
            return new Promise((resolve) => {
                let req = this.myaxios.getNoloading(`/api/AcisSystem/Config/GetByKey?key=otherScheduleIntervalTime`)
                req.then(data => {
                    if (data && data.value && data.value.trim() && data.value.trim() != ``) {
                        this.otherScheduleIntervalTime = parseInt(data.value)
                    }
                    resolve(this.otherScheduleIntervalTime)
                }).catch(e => {
                    console.log(e)
                })
            })
        },
        addotherscheduleBefore() {
            this.otherscheduleEditData.data = {
                start_time: this.$moment().format(`YYYY/MM/DD HH:mm`),
                end_time: this.$moment().add(this.otherScheduleIntervalTime, `minutes`).format(`YYYY/MM/DD HH:mm`)
            }
            this.otherscheduleEditData.dialogFormVisible = true
        },
        saveotherschedule(row) {
            row.effective_start_time = row.effectivetime.length >= 2 ? row.effectivetime[0] : ``
            row.effective_end_time = row.effectivetime.length >= 2 ? row.effectivetime[1] : ``
            row.is_limit_time = null
            if (row.repeat_value != null && row.repeat_value.indexOf(`,`) == -1 && typeof row.repeat_value != `string`) {
                row.repeat_value = row.repeat_value != null ? row.repeat_value.join(`,`) : ``
            }
            if (row.tmp_operatingroom_ids != null && row.tmp_operatingroom_ids.length > 0) {
                row.dic_operatingroom_ids = row.tmp_operatingroom_ids.join(`,`)
            }
            console.log(row)
            this.myaxios.post(
                `/api/AcisSystem/OtherSchedule/Post`,
                row
            ).then(data => {
                this.$message.success(`保存成功`)
                this.otherscheduleEditData.dialogFormVisible = false
                this.$emit(`refetchRightData`)

                this.reloadList()
            })
        },
        editotherschedule(row) {
            row.effectivetime = []
            row.effectivetime.push(row.effective_start_time)
            row.effectivetime.push(row.effective_end_time)

            if (row.dic_operatingroom_ids != null) {
                row.tmp_operatingroom_ids = row.dic_operatingroom_ids.split(`,`).map(d => parseInt(d))
            }
            row.is_limit_time = false
            this.otherscheduleEditData.dialogFormVisible = true
            this.otherscheduleEditData.data = row
        },
        showEditOtherSchedule(id) {
            this.LoadScheduled(3).then((data) => {
                let row = _.find(data, { 'id': parseInt(id) })
                console.log(`showEditOtherSchedule`)
                console.log(row)
                this.editotherschedule(row)
            })
        },
        removeotherschedule(row) {
            this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.delete(`/api/AcisSystem/OtherSchedule/Delete/${row.id}`)
                req.then(() => {
                    this.$message.success(`删除成功`)
                    this.reloadList()
                    this.$emit(`refetchRightData`)
                })
            })
        },
        dbschedule(row) {
            this.editSurgeryInfo.surgeryId = row.id
            this.editSurgeryInfo.dialogFormVisible = true
            this.editSurgeryInfo.isReadOnly = !this.isHaveCardEdit
            if (row.enum_surgery_status == 10) {
                this.editButtons = [{
                    label: `确认排程`,
                    type: `default`,
                    permission: `ApplySurgery:ConfirmSchedule`
                }]
            } else {
                this.editButtons = []
            }
        },
        addSurgeryTips(surgeryId, patientInfo) {
            this.SurgeryTips.dialogFormVisible = true
            this.SurgeryTips.surgeryId = surgeryId
            this.SurgeryTips.patientInfo = patientInfo
        },
        delPatientTip(tipname, surgeryId) {
            let req = this.myaxios.delete(`/api/AcisSystem/BizSurgeryTips/Delete?tipname=${tipname}&surgeryId=${surgeryId}`)
            req.then(() => {
                this.$message.success(`删除成功`)
                this.reloadList()
            })
        },
        siwtchBtn(event, row) {
            event.currentTarget.querySelector(`.switch`).click()
        },
        siwtchdutyBtn(event, row) {
            event.currentTarget.querySelector(`.switch`).click()
        },
        changeCheck(event, row) {
            if (row.checked == true) {
                this.checkedRow.push(row)
                if (this.scheduledType == 2) {
                    this.$emit(`mouseOver`, row)
                }
                let bedcardview = this.getBedcardview()
                if (bedcardview) {
                    bedcardview.refreshList(row)
                }
            } else {
                this.checkedRow = this.checkedRow.filter(item => item.checked)
                if (this.scheduledType == 2) {
                    this.$emit(`mouseOut`, row)
                }
            }
        },
        reEmitCheckedChange() {
            this.$emit(`checked`, this.checkedRow)
        },
        mouseOver(row) {
            this.$set(row, `mouseFlag`, true)
            this.$emit(`mouseOver`, row)
        },
        mouseOut(row) {
            this.$set(row, `mouseFlag`, false)
            this.$emit(`mouseOut`, row)
        },
        rightschedule(row) {
            if (this.checkedRow.length > 0) {
                var r = this.checkedRow.filter(item => item.enum_surgery_status == -1 || item.enum_surgery_status == -2 || item.enum_surgery_status == 30 || item.enum_surgery_status == 40 || item.enum_surgery_status == 60)
                if (r.length == 0) {
                    this.$emit(`showchangeRoom`, this.checkedRow)
                } else {
                    this.$message.warning(`不允许操作手术中、手术结束、苏醒中、苏醒结束的手术`)
                }
            } else {
                this.$message.warning(`请选择手术！`)
            }
        },
        batchScheduling(row) {
            if (this.checkedRow.length > 0) {
                var r = this.checkedRow.filter(item => item.enum_surgery_status == -1 || item.enum_surgery_status == -2 || item.enum_surgery_status == 30 || item.enum_surgery_status == 40 || item.enum_surgery_status == 60)
                if (r.length == 0) {
                    let bedcardview = this.getBedcardview()
                    let rightScheduleSurgery = this.getRightScheduleSurgery()
                    if (!bedcardview || bedcardview.active_room_id == 0) {
                        this.$message.warning(`请选择手术间!`)
                        return
                    }

                    let surgeryIds = []
                    let msgs = ``
                    this.checkedRow.map(d => {
                        // 存在非当前手术区的数据，弹出提示
                        if (d.dic_operating_ward_id != rightScheduleSurgery.dic_operating_ward_id) {
                            msgs += `(“${d.patient_name}”、“${d.visit_no || `--`}”)、`
                        }
                        surgeryIds.push(d.id)
                    })

                    let row = {
                        status: 10, // 新申请
                        dic_operating_room_id: bedcardview.active_room_id,
                        dic_recovery_ward_id: rightScheduleSurgery.dic_operating_ward_id
                    }

                    if (msgs != ``) {
                        msgs = msgs.slice(0, msgs.length - 1)
                        return this.$confirm(`请确认${msgs}是否跨区排程?`, `提示`, {
                            confirmButtonText: `确定`,
                            cancelButtonText: `取消`,
                            type: `warning`,
                            closeOnClickModal: false
                        }).then(() => {
                            rightScheduleSurgery.getchangeRoomSave(row, surgeryIds)
                        }).catch(e => {})
                    } else {
                        rightScheduleSurgery.getchangeRoomSave(row, surgeryIds)
                    }
                } else {
                    this.$message.warning(`不允许操作手术中、手术结束、苏醒中、苏醒结束的手术`)
                }
            } else {
                this.$message.warning(`请选择手术！`)
            }
        },
        save(surgeryId, surgeryStatus, operatingRoomId, planTime) {
            this.editSurgeryInfo.dialogFormVisible = false
            this.$emit(`refetchRightData`)
            this.reloadList()
        },
        afterClose(surgeryTipItemsList) {
            this.reloadList()
        },
        afterSave(surgeryId, surgeryStatus, operatingRoomId, planTime) {
            this.editSurgeryInfo.dialogFormVisible = false
            let that = this
            let ptime = this.$moment(planTime).format(`YYYY/MM/DD HH:mm:00`)
            let surgeryIds = []
            if (surgeryStatus == 10) {
                surgeryIds.push(surgeryId)
                that.checkSurgery(surgeryIds).then((d) => {
                    if (d && d != ``) {
                        this.$confirm(d, `提示`, {
                            confirmButtonText: `确定排程`,
                            cancelButtonText: `取消排程`,
                            type: `warning`,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                that.doScheduleSurgeries(ptime, operatingRoomId, surgeryIds)
                            })
                            .catch(e => {
                                this.reloadList()
                            })
                    } else {
                        that.doScheduleSurgeries(ptime, operatingRoomId, surgeryIds)
                    }
                })
            }
        },
        checkSurgery(ids) {
            // 存储校验
            return new Promise((resolve, reject) => {
                let that = this // , int[] surgeryIds
                let req = that.myaxios.put(`/api/Preoperative/Schedule/CheckSurgery`, ids)
                req.then(d => {
                    resolve(d)
                }).catch(e => {
                    reject(e)
                })
            })
        },
        doScheduleSurgeries(schedulingDate, operatingRoomId, surgeryIds) {
            let that = this
            let req = that.myaxios.put(`/api/Preoperative/Schedule/ScheduleSurgeries?date=${schedulingDate}&roomId=${operatingRoomId}`, surgeryIds)
            req.then(data => {
                this.$emit(`refetchRightData`)
                this.reloadList()
            }).catch(e => {
                that.$message.error(`排程失败`)
            })
        },
        reloadList() {
            this.LoadScheduled(this.scheduledType).then((data) => {
            })
        },
        reloadRoomSettingWorkers(rdate) {
            let that = this
            return new Promise(resolve => {
                let req2 = that.myaxios.getNoloading(`/api/Preoperative/RoomSetting/GetRoomSettingWorkersByDate`, { date: rdate })
                req2.then(data1 => {
                    that.used_workers = data1
                    that.loadunsettingWorkers(that.workers_all, that.used_workers)
                    resolve(that.used_workers)
                }).catch(e => {
                    that.used_workers = []
                })
            })
        },
        removeLeftSelectData(id) {
            // 右侧日历勾选了数据，左侧待办列表清空勾选
            if (this.scheduledType == 1) {
                _.forEach(this.checkedRow, row => {
                    row.checked = false
                    this.changeCheck(null, row)
                })
            } else if (this.scheduledType == 2) {
                // 右侧日历勾选了数据，左侧已办列表比对后删除勾选
                let row = _.find(this.checkedRow, { id: id })
                if (row) {
                    row.checked = false
                    this.changeCheck(null, row)
                }
            }
        },
        groupListRightClick(row) {
        },
        createDraggable(data) {
            let that = this
            that.$nextTick(() => {
                let calendarEls = document.getElementsByClassName(`event`)
                for (let index = 0; index < calendarEls.length; index++) {
                    let con = calendarEls[index]

                    let item = _.find(data, { id: parseInt(con.id) })
                    if (item) {
                        let isnotexist = _.findIndex(that.draggableCollection, function(t) {
                            return t.settings.eventData.id == item.id
                        })
                        if (isnotexist > -1) {
                            that.draggableCollection[isnotexist].destroy()
                            that.draggableCollection.splice(isnotexist, 1)
                            let drag = new Draggable(con, {
                                eventData: {
                                    id: item.id,
                                    costTime: item.cost_time,
                                    color: that.$getThemePrimaryColor(),
                                    startEditable: true,
                                    durationEditable: true,
                                    resourceEditable: true,
                                    editable: true,
                                    extendedProps: { ...item }
                                }
                            })
                            that.draggableCollection.push(drag)
                        } else {
                            let drag = new Draggable(con, {
                                eventData: {
                                    id: item.id,
                                    costTime: item.cost_time,
                                    color: that.$getThemePrimaryColor(),
                                    startEditable: true,
                                    durationEditable: true,
                                    resourceEditable: true,
                                    editable: true,
                                    extendedProps: { ...item }
                                }
                            })
                            that.draggableCollection.push(drag)
                        }
                    }
                }
                console.log(`创建的createDraggable 拖拽对象集合`, that.draggableCollection)
            })
        },
        isChecked(row) {
            let that = this
            let num = ``
            if (this.scheduledType != 1) {
                return ``
            }
            let idx = _.findIndex(that.checkedRow, c => {
                return c.id == row.id
            })
            if (idx !== -1) {
                num = idx + 1
            }
            return num
        }, // ,
        // rowDrop() {
        //     // 行拖拽 el-scrollbar__view
        //     let _this = this
        //     _this.$nextTick(() => {
        //         let tbodys = document.querySelectorAll(`.menuEvents`)
        //         _.forEach(tbodys, tbody => {
        //             Sortable.create(tbody, {
        //                 group: { name: `ulEvents`, push: false, put: false },
        //                 animation: 180,
        //                 fallbackOnBody: true,
        //                 delay: 0,
        //                 ghostClass: `sortable-tr-ghost`, // 占位符类名，添加样式
        //                 chosenClass: `sortable-tr-chosen`, // 所选项目的类名，添加样式
        //                 dragClass: `sortable-tr-drag`, // 拖动项目类名，添加样式,
        //                 setData: function(dataTransfer, dragEl) {
        //                     let draghtml = ` `
        //                     if (_this.checkedRow && _this.checkedRow.length > 0) {
        //                         draghtml = _.join(
        //                             _.map(_this.checkedRow, d => d.drag_html || `1111111111`),
        //                             `<br/>`
        //                         )
        //                     } else {
        //                         draghtml = ``
        //                     }
        //                     var ghost = document.createElement(`div`)
        //                     ghost.id = `GHOST_LABEL`
        //                     ghost.style.background = `#ffff`
        //                     ghost.style.color = `#606266`
        //                     ghost.style.padding = `20px 10px 20px 15px`
        //                     ghost.style.fontSize = `16px`
        //                     // ghost.style.opacity = '1'
        //                     ghost.style.textAlign = `left`
        //                     ghost.style.lineHeight = `20px`
        //                     ghost.innerHTML = draghtml
        //                     ghost.style.display = `inline`
        //                     ghost.style.position = `absolute`
        //                     ghost.style.left = `-2000px`
        //                     ghost.style.top = `0px`
        //                     document.body.appendChild(ghost)
        //                     // var img = new Image();
        //                     // img.src = 'static/img/defaultImg.jpg';
        //                     dataTransfer.setDragImage(ghost, -10, -10)
        //                 // dataTransfer.setDragImage('Text', dragEl.textContent); // `dataTransfer` object of HTML5 DragEvent
        //                 }
        //             })
        //         })

        //         let containerEl = document.getElementById(`external-events`)
        //         let thirdParty = new ThirdPartyDraggable(containerEl, {
        //             itemSelector: `.event`,
        //             mirrorSelector: `.sortable-tr-drag`, // the dragging element that dragula renders
        //             eventData: {
        //                 id: 1,
        //                 costTime: 2,
        //                 color: `#009688`,
        //                 startEditable: true,
        //                 durationEditable: true,
        //                 resourceEditable: true,
        //                 editable: true,
        //                 extendedProps: { id: 1, title: `aaaaaaaaa` }
        //             }
        //         })

        //         // let calendarEls = document.getElementsByClassName(`event`)
        //         // let con = calendarEls[0]
        //         // let thirdParty = new Draggable(con, {
        //         //     eventData: {
        //         //         id: 1,
        //         //         costTime: 2,
        //         //         color: `#009688`,
        //         //         startEditable: true,
        //         //         durationEditable: true,
        //         //         resourceEditable: true,
        //         //         editable: true,
        //         //         extendedProps: { id: 1, title: `aaaaaaaaa` }
        //         //     }
        //         // })
        //         console.log(thirdParty)
        //     })
        // }
        loadWorkers() {
            this.scheduledType = 4
            this.getWorkers()
        },
        getWorkers() {
            let that = this
            let rdate = new Date()
            let fullcalendarview = this.$parent.$parent.$parent
            if (fullcalendarview && fullcalendarview.$refs.RightScheduleSurgery) {
                let RightScheduleSurgery = fullcalendarview.$refs.RightScheduleSurgery
                rdate = RightScheduleSurgery.rdate
            }
            return new Promise(resolve => {
                let req1 = that.myaxios.getNoloading(`/api/AcisSystem/Worker/ItemsHaveSection`)
                let req2 = that.myaxios.getNoloading(`/api/Preoperative/RoomSetting/GetRoomSettingWorkersByDate`, { date: rdate })
                this.myaxios.all(req1, req2).then(([data1, data2]) => {
                    that.workers_all = _.filter(data1, d => { return !d.is_deleted && !d.is_system && d.enum_worker_role > 0 }).map(d => {
                        let workerduty = d.worker_duty
                        if (workerduty == `麻醉助手`) workerduty = `麻醉医生`
                        else if (workerduty == `手术助手`) workerduty = `手术医生`
                        else if (workerduty == `器械护士`) workerduty = `巡回护士`
                        else if (workerduty == `复苏护士` || workerduty == `麻醉护士`) workerduty = `巡回护士`
                        return {
                            name: d.name,
                            id: d.id,
                            abbr: d.abbr,
                            card_no: d.card_no,
                            enum_worker_role: d.enum_worker_role,
                            worker_duty: workerduty,
                            checked: false
                        }
                    })
                    that.used_workers = data2
                    this.loadunsettingWorkers(that.workers_all, that.used_workers)
                    resolve(that.workers_all)
                }).catch(e => {
                    that.workers_all = []
                    that.used_workers = []
                })
            })
        },
        loadunsettingWorkers(allworkers, usedworkers) {
            let that = this
            that.un_setting_workers = allworkers.filter(d => {
                return !_.includes(usedworkers, d.id)
            })
        },
        loadWorkersByDuty(index) {
            let that = this
            that.getWorkers()
            this.workerDuty = index
        },
        setRoomDutyWorker(workerDuty, workerId) {
            let workers = [workerId]
            let checkedworkers = _.filter(this.un_setting_workers, (d) => {
                return (d.checked == true)
            }).map(i => i.id)
            if (checkedworkers && checkedworkers.length > 0) {
                workers = checkedworkers
            }
            let that = this
            let rightScheduleSurgery = this.getRightScheduleSurgery()
            let bedcardview = this.getBedcardview()
            if (bedcardview) {
                bedcardview.setRoomDutyWorker(workerDuty, workers)
                    .then(data => {
                        that.reloadRoomSettingWorkers(rightScheduleSurgery.rdate)
                    })
            }
        },
        getBedcardview() {
            let fullcalendarview = this.$parent.$parent.$parent
            if (fullcalendarview && fullcalendarview.$refs.RightScheduleSurgery) {
                let RightScheduleSurgery = fullcalendarview.$refs.RightScheduleSurgery
                if (!RightScheduleSurgery.isshowCalendar) {
                    let bedcardview = RightScheduleSurgery.$refs.bedcardview
                    return bedcardview
                } else {
                    return null
                }
            } else {
                return null
            }
        },
        getRightScheduleSurgery() {
            let fullcalendarview = this.$parent.$parent.$parent
            if (fullcalendarview && fullcalendarview.$refs.RightScheduleSurgery) {
                return fullcalendarview.$refs.RightScheduleSurgery
            } else {
                return null
            }
        }

    },
    destroy() {

    },
    watch: {
        rdate: function() {
            this.reloadList()
        },
        searchType: function() {
            this.reloadList()
        },
        active_ward: function() {
            if (this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                this.dic_operating_ward_id = this.active_ward.origion
                sessionStorage.setItem(`memory_operating_ward_id`, parseInt(this.dic_operating_ward_id))
            }

            this.reloadList()
        },
        groupbymodel: function() {
            this.sxvalue = 0
        },
        checkedRow: function() {
            this.reEmitCheckedChange()
        },
        workerDuty: function() {
            this.un_setting_workers.map(i => {
                i.checked = false
                return i
            })
        }
    }
}
</script>

<style scoped lang="less">
.surgeryStatusbgColor{
    /deep/ .el-submenu__title{
        background: #FFA500 !important;
    }
}
.sub-menu {
    height: 35px;
    /*background: #fff;*/
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    color: #a1aaac;
    .p_name {
        color: #3c4758;
    }
    .el-col {
        &:first-of-type {
            line-height: 35px;
        }
    }
}
.el-icon-search {
    color: red;
    cursor: pointer;
    &:hover {
        color: whitesmoke;
    }
}
.bg-end {
    color: rgb(220, 223, 230);
    background-color: rgb(220, 223, 230);
}
.bg-danger {
    color: rgb(234, 162, 0);
    background-color: red;
}
</style>
<style lang="less">
/* 拖拽时的样式控制 */
.room tr {
    display: none;
}
.room .drag_target {
    color: black !important;
    outline: dotted 0.5px gray;
}
.surgery-status-tag {
    width: 12px;
    float: left;
    height: 100px;
}
.surgery-num-tag {
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    // display: -moz-inline-box; /* css注释：for ff2 */
    // display: inline-block;
    float: right;
    margin-right: 10px;
}
.el-tag-dp {
    color: #52b8d2;
    border-color: #52b8d2;
    background-color: white;
}
.workerImg {
    float: left;
    padding: 2px 15px;
    width: 16px;
    height: 16px;
}
.workerImg:hover {
    cursor: pointer;
    transform: scale(1.2);
}
.surgery-index-popover {
    .el-radio,
    .el-checkbox {
        width: 130px;
        margin: 0 10px 5px 0;
        overflow: hidden;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Scheduling/LeftScheduleSurgery.vue